var _rect, _path, _rect2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJAngKIconsMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 21,
    viewBox: "0 0 46 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    width: 21,
    height: 21,
    rx: 3,
    fill: "#1A1A1A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.896 14.25V6.97727H33.2135V10.3189H33.3023L36.1396 6.97727H37.7483L34.9358 10.2408L37.7732 14.25H36.1894L34.0196 11.1321L33.2135 12.0838V14.25H31.896Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    rx: 3,
    transform: "matrix(-1 0 0 1 21 0)",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2839 6.97727H12.5907V12.0909C12.5884 12.5597 12.4889 12.9633 12.2924 13.3018C12.0959 13.638 11.8213 13.8973 11.4686 14.0795C11.1182 14.2595 10.7098 14.3494 10.2434 14.3494C9.81729 14.3494 9.43377 14.2737 9.09286 14.1222C8.75432 13.9683 8.48562 13.741 8.28675 13.4403C8.08789 13.1397 7.98846 12.7656 7.98846 12.3182H9.29883C9.3012 12.5147 9.34381 12.6839 9.42667 12.826C9.5119 12.968 9.62908 13.0769 9.77823 13.1527C9.92738 13.2285 10.099 13.2663 10.2931 13.2663C10.5038 13.2663 10.6826 13.2225 10.8294 13.1349C10.9761 13.045 11.0874 12.9124 11.1632 12.7372C11.2413 12.562 11.2815 12.3466 11.2839 12.0909V6.97727Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJAngKIconsMobile);
export default __webpack_public_path__ + "static/media/JAngKIconsMobile.2f60d6f2c3c5ad5273517d4c2d3700c1.svg";
export { ForwardRef as ReactComponent };